<zah-regioverantwoordelijken [initialPageRequest]="initialPageRequest"
                             [regioverantwoordelijkenPage]="regioverantwoordelijkenPage$ | async"
                             (regioverantwoordelijkeClicked)="navigateToRegioverantwoordelijke($event)"
                             (deleteClicked)="deleteRegioverantwoordelijke($event)"
                             (addClicked)="navigateToAddRegioverantwoordelijke()"
                             (pageChange)="onPageChange($event)">
</zah-regioverantwoordelijken>
